import React from "react";

function CustOrders() {
  return <div>Customer Orders Page</div>;
}

export default CustOrders;
